export default "__VITE_PUBLIC_ASSET__c383b870__"